/**
 * Prompt template for exporting the layout to external agents.
 * Wraps exported HTML/CSS so coding agents can integrate the design.
 */

const EXPORT_PROMPT_TEMPLATE = `This is a UI design exported as HTML/CSS from Banani. Integrate it into my project, adapting it to match my existing tech stack, component library, and styles. Preserve the layout, spacing, and visual design as closely as possible.

Instructions:
- Convert the HTML/CSS into components that fit my project's framework and conventions
- Replace inline styles with my project's styling approach (e.g., Tailwind classes, CSS modules, styled-components)
- Use existing UI components from my project where appropriate
- Ensure the result is responsive and accessible
- Remove any Banani-specific artifacts (export wrappers, CDN scripts)

\`\`\`html
<design>
{{HTML}}
</design>
\`\`\`
`;

export function getExportPrompt(html: string): string {
  return EXPORT_PROMPT_TEMPLATE.replace('{{HTML}}', html);
}
